import { FormGroup, Label, Input, Col, FormFeedback } from 'reactstrap'
import { Controller } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { manualUploadsSlice } from '../../../redux/slices'
import '../ManualUploads.css'

const ManualUploadsSector = ({
  name,
  id = `${name}Input`,
  control,
  errors,
  defaultValue = undefined,
  required,
  visible,
  label
}) => {

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref }
      }) => {
        return (
          <FormGroup className='sector-input'>
            <Col className='manual-uploads-col sector'>
              <Label for={`${name}_input`} className='manual-uploads-label'>
                {label}
              </Label>
              <input
                type='number'
                id={`${name}_input`}
                name={name}
                ref={ref}
                className='manual-uploads-input form-control'
                min={0}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                //required={required}
                // placeholder={value}
              />
              <FormFeedback
                valid={errors?.[name] ? false : true}
                role='alert'
                id={`${name}Error`}
                style={visible ? {display:'block'} : {display: 'hidden'}}
              >
                {errors?.[name]?.message}
              </FormFeedback>
            </Col>
          </FormGroup>
        )
      }}
    />
  )
}

export default ManualUploadsSector
